import { View, Text } from '@react-pdf/renderer';
import theme from '../../../theme';
import { PdfDocumentProps } from './ExportPdf';
import formatNewLines from '../../../lib/helper/format-new-lines';

export type PdfClinicalReviewsProps = Pick<PdfDocumentProps, 'caseDetails'>;

const PdfClinicalReviews = ({ caseDetails: data }: PdfClinicalReviewsProps) => {
    return (
        <>
            {data && (
                <View
                    style={{
                        padding: 5,
                        border: '2px solid black',
                        borderColor: theme.palette.appBackground.main,
                        width: '97%',
                        margin: 'auto',
                        marginTop: 3,
                        borderRadius: '10',
                        fontSize: 8
                    }}>
                    {data.clinicalReviews.map((item, i) => (
                        <View key={i}>
                            {(item.nurseConclusions || item.comorbidityIndexScore) && (
                                <View style={{ paddingVertical: 5 }}>
                                    <Text style={{ fontWeight: 'bold', fontSize: 13 }}>
                                        {item.nurseActivity}
                                    </Text>
                                    <Text style={{ fontWeight: 'bold' }}>
                                        Reviewed by {item.nurseName}
                                    </Text>
                                    <Text>{formatNewLines(item.nurseConclusions)}</Text>

                                    <Text style={{ marginTop: 5, fontWeight: 'bold' }}>
                                        Comorbidity Index Score: {item.comorbidityIndexScore}
                                    </Text>
                                    {item.prosthetics && (
                                        <Text>
                                            Implant Information (Prosthetics): {item.prosthetics}
                                        </Text>
                                    )}
                                    {item.medicalDevices && (
                                        <Text>
                                            Implant Information (Medical Devices):{' '}
                                            {item.medicalDevices}
                                        </Text>
                                    )}
                                    {item.instrumentation && (
                                        <Text>
                                            Implant Information (Instrumentation):{' '}
                                            {item.instrumentation}
                                        </Text>
                                    )}
                                    {item.grafts && (
                                        <Text>Implant Information (Grafts): {item.grafts}</Text>
                                    )}
                                </View>
                            )}
                            {item.nurseDecision && (
                                <View style={{ paddingVertical: 5 }}>
                                    <Text style={{ fontWeight: 'bold' }}>Nurse Conclusions</Text>
                                    <Text style={{ fontWeight: 'bold' }}>
                                        Reviewed by {item.nurseName}
                                    </Text>
                                    <Text>{formatNewLines(item.nurseDecision)}</Text>
                                </View>
                            )}
                            {item.physicianName && (
                                <View style={{ paddingVertical: 5 }}>
                                    <Text style={{ fontWeight: 'bold', fontSize: 13 }}>
                                        {item.physicianActivity}
                                    </Text>
                                    <Text>{formatNewLines(item.physicianReview)}</Text>
                                </View>
                            )}
                            {item.isAppAppropriateValue && (
                                <View style={{ paddingVertical: 5 }}>
                                    <Text>APP Appropriate: {item.isAppAppropriateValue}</Text>
                                </View>
                            )}
                            {item.isAppAppropriateValue === 'Yes' && (
                                <View style={{ paddingVertical: 5 }}>
                                    <Text>APP Reason: {item.appP2PReason}</Text>
                                </View>
                            )}
                            {item.spanishPhysicianReview && (
                                <View style={{ paddingVertical: 5 }}>
                                    <Text style={{ fontWeight: 'bold', fontSize: 13 }}>
                                        {item.physicianActivity} (Spanish)
                                    </Text>
                                    <Text>{formatNewLines(item.spanishPhysicianReview)}</Text>
                                </View>
                            )}
                        </View>
                    ))}
                </View>
            )}
        </>
    );
};

export default PdfClinicalReviews;
